var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRender)?_c('adjust-config',{attrs:{"params":_vm.params}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }